<div
    class="drop-shadow-1"
    [ngClass]="isExpanded() ? 'expanded-card' : 'normal-card'"
    (mouseenter)="onHover('in')"
    (mouseleave)="onHover('out')">
    <div class="padding-1 clip4 primary-gradient-bg-100 rounded-1 h-100">
        <div class="clip4 flip-card-front overflow-hidden rounded-1 h-100">
            <div class="user-card p-2 d-flex flex-column rounded-1 content-card h-100">
                <ng-container *ngTemplateOutlet="tile; context: { $implicit: data() }"></ng-container>
            </div>
        </div>
    </div>
</div>

@if (showSelection() && !isExpanded()) {
    <div
        class="carousel-selection position-absolute"
        [id]="data().id"
        (click)="onSelectionChange(data())">
        <label
            [attr.data-is-checked]="data().isChecked()">
        </label>
    </div>
}

@if (showCount() && !isExpanded()) {
    <div
        class="carousel-selection position-absolute"
        [id]="data().id">
        <label class="font-4 text-center primary-text">{{data().quantity()}}</label>
    </div>
}


<ng-template
    #tile
    let-val>
    <presenter
        [key]="'tileTop'"
        [data]="val"></presenter>

    @if (isExpanded()) {
        <presenter
            [key]="'tileBottom'"
            [data]="val"></presenter>
    }
</ng-template>
